import { GetMentorFormServices } from "./service";
import { toast } from "react-toastify";
import {
  // GET_A_MENTOR_FORM,
  VIEW_STARTUP_APPLICATION_DATA,
  GET_SESSION_DATA,
  GET_SUMMARY_DATA,
} from "../../common/constants/actionConstants";
import swal from "sweetalert";
import { isLoading } from "../../common/dependencies/action/action";

export const getMentorForms = (params) => (dispatch) => {
  // dispatch(isLoading(true));
  // return getBindMentorFormData(params).then((data) => {
  //   const { mentorFormList } = data;
  //   //
  //   if (mentorFormList) {
  //     dispatch({
  //       type: GET_A_MENTOR_FORM,
  //       payload: mentorFormList,
  //     });
  //   }
  //   dispatch(isLoading(false));
  // });
};

export const registerStartUp = (params,action) => async (dispatch) => {
  //
  dispatch(isLoading(true));
  return GetMentorFormServices.registerStartUp(params)
    .then((response) => {
      //
      if (response?.data?.success) {
        dispatch(isLoading(false));
        // toast.success("Your Application Submitted Successfully");
        // if (action === "VERIFIED") {
        //   swal("Thank you", " Your Profile Updated Successfully", "success", {
        //     closeOnClickOutside: false,
        //   });
        // } else {
        //   swal(
        //     "Thank you",
        //     " Application Submitted Successfully." +
        //       " To View Your Application Status, Log In again.",
        //     "success",
        //     { closeOnClickOutside: false }
        //   );
        // } completeApplication   editProfile
        // alert(action)
        if(action && action=="completeApplication" ){
          swal(
            "Thank you",
            " Application Submitted Successfully.",
            "success",
            { closeOnClickOutside: false }
          );
        }else if(action && action=="editProfile" ){
          swal(
            "Thank you",
            "Profile Updated Successfully.",
            "success",
            { closeOnClickOutside: false }
          );
        }else{
        }


      
        return true;
      } else {
        dispatch(isLoading(false));
        // window.location.href = "/";
        // toast.error(response?.data?.errors[0]?.message);
        swal("Unable to Submit Form", "It will take a while....Please Try Again", "error", {
          closeOnClickOutside: false,
        });
        return false;
      }
    })
    .catch((error) => {
      // toast.error(INTERNAL_SERVER_ERROR);
      swal("Unable to Submit Form", "It will take a while....Please Try Again", "error", {
        closeOnClickOutside: false,
      });
      dispatch(isLoading(false));
    });
};

export const savedraftStartUp = (params, buttontype,action) => async (dispatch) => {
  //
  
  if (buttontype === "savedraftbutton") {
    dispatch(isLoading(true));
  }
  // dispatch(isLoading(true));
  return GetMentorFormServices.savedraftStartUp(params)
    .then((response) => {
      //
      if (response?.data?.success) {
        dispatch(isLoading(false));
        // toast.success("Your Application Submitted Successfully");
        // if (action === "VERIFIED") {
        //   swal("Thank you", " Your Profile Updated Successfully", "success", {
        //     closeOnClickOutside: false,
        //   });
        // } else {
        //   swal(
        //     "Thank you",
        //     " Application Submitted Successfully." +
        //       " To View Your Application Status, Log In again.",
        //     "success",
        //     { closeOnClickOutside: false }
        //   );
        // }

        if (buttontype === "savedraftbutton") {
          dispatch(isLoading(false));
if(action==="completeApplication"){
  swal(
    "Thank you",
    " Draft Saved Successfully. Please Complete Your Application to Submit,Login Again",
    // " To View Your Application Status, Log In again.",
    "success",
    { closeOnClickOutside: false }
  );
}else{
  swal(
    "Thank you",
    " Draft Saved Successfully, Please Complete Your Application To Submit.",
    // " To View Your Application Status, Log In again.",
    "success",
    { closeOnClickOutside: false }
  );
}
         
        }

        // swal(
        //   "Thank you",
        //   " Draft saved Successfully.",
        //   // " To View Your Application Status, Log In again.",
        //   // "success",
        //   { closeOnClickOutside: false }
        // );
        return true;
      } else {
        dispatch(isLoading(false));
        // window.location.href = "/";
        // toast.error(response?.data?.errors[0]?.message);
        // swal("Failed", "Please Try Again", "error", {
        //   closeOnClickOutside: false,
        // });
        return false;
      }
    })
    .catch((error) => {
      // toast.error(INTERNAL_SERVER_ERROR);
      dispatch(isLoading(false));
    });
};

export const getViewApplicationData = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindData(params).then((data) => {
    //
    const { getViewApplicationData } = data;
    if (getViewApplicationData) {
      dispatch({
        type: VIEW_STARTUP_APPLICATION_DATA,
        payload: getViewApplicationData,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindData(params) {
  const getViewApplicationData =
    await GetMentorFormServices.getViewApplicationData(params).catch((e) => {
      return { data: [], status: false };
    });
  return { getViewApplicationData };
}
export const getSessionData = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindSessionData(params).then((data) => {
    //
    const { getSessionData } = data;
    if (getSessionData) {
      dispatch({
        type: GET_SESSION_DATA,
        payload: getSessionData,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindSessionData(params) {
  const getSessionData = 
    await GetMentorFormServices.getViewSessionData(params).catch((e) => {
      return { data: [], status: false };
    });
  return { getSessionData };
}

export const getSummaryData = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindSummaryData(params).then((data) => {
    //
    const { getSummaryData } = data;
    if (getSummaryData) {
      dispatch({
        type: GET_SUMMARY_DATA,
        payload: getSummaryData,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindSummaryData(params) {
  const getSummaryData =
    await GetMentorFormServices.getViewSummaryData(params).catch((e) => {
      return { data: [], status: false };
    });
  return { getSummaryData };
}

async function getBindMentorFormData() {
  const mentorFormList =
    await GetMentorFormServices.getMentorFormServices().catch((e) => {
      return { data: [], status: false };
    });

  return { mentorFormList };
}
